import { apiRequestGet } from 'mastodon/api';
import type { AppDispatch } from 'mastodon/store';

export const MESSAGES_THREADS_FETCH_SUCCESS = 'MESSAGES_THREADS_FETCH_SUCCESS';
export const MESSAGES_MESSAGE_RECEIVED = 'MESSAGES_MESSAGE_RECEIVED';
export const MESSAGES_THREAD_READ = 'MESSAGES_THREAD_READ';

export interface MessageAccount {
  id: string;
  username: string;
  acct: string;
  display_name: string;
  avatar: string;
  avatar_static: string;
  online: boolean;
  last_active_at: string | null;
}

export interface MessageItem {
  id: string;
  content: string;
  created_at: string;
  sender: MessageAccount;
}

export interface MessageThread {
  id: string;
  created_at: string;
  updated_at: string;
  account: MessageAccount;
  last_message: MessageItem | null;
  unread_count: number;
}

export interface MessageCreatePayload {
  message: MessageItem;
  thread: MessageThread;
  unread_count: number;
}

export const messagesThreadsFetchSuccess = (threads: MessageThread[]) => ({
  type: MESSAGES_THREADS_FETCH_SUCCESS,
  threads,
});

export const messageReceived = (payload: MessageCreatePayload) => ({
  type: MESSAGES_MESSAGE_RECEIVED,
  payload,
});

export const messageThreadRead = (thread: MessageThread) => ({
  type: MESSAGES_THREAD_READ,
  thread,
});

export const fetchMessageThreadsForBadge =
  () => async (dispatch: AppDispatch) => {
    const threads = await apiRequestGet<MessageThread[]>('v1/messages/threads');
    dispatch(messagesThreadsFetchSuccess(threads));
  };
